import React from "react";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";

type Props = {
  handleSubmit: () => void;
  toggle: () => void;
  modalStatus: string;
};

function AddTerritoryModal({ handleSubmit, toggle ,modalStatus}: Props) {
  return (
    <div>
      <CustomInput
        label="Name*"
        type="text"
        //   value={leaveTo}
        style={{
          backgroundColor: "transparent",
          border: "0.2px solid #d4d4d4",
          flex: 1,
        }}
        // onChange={(e) => handleChange(e, "LeaveReason")}
        onChange={(e) => console.log(e, "LeaveTo")}
      />
      <ReusableDropdown
        options={[]}
        onChange={(value: any) => {
          console.log("Selected leave type:", value);
          // setSelectedLeaveStatus(value); // Store only the ID as a number
        }}
        DropdownHeading="Org Unit"
        //   value={selectedLeaveStatus?.toString()}
      />
      <ReusableDropdown
        options={[]}
        onChange={(value: any) => {
          console.log("Selected leave type:", value);
          // setSelectedLeaveStatus(value); // Store only the ID as a number
        }}
        DropdownHeading="Position"
        //   value={selectedLeaveStatus?.toString()}
      />
      <div style={{ marginTop: "15px" }}>
        <button onClick={handleSubmit} className="btn btn-primary">
          Submit
        </button>
        <button
          onClick={() => toggle()}
          className="btn btn-light"
          style={{ color: "gray", marginLeft: "10px" }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

export default AddTerritoryModal;
